var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui items"},[_c('div',{staticClass:"item"},[(_vm.imageUrl)?_c('div',{staticClass:"ui mini image"},[_c('img',{attrs:{"src":_vm.imageUrl}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"top aligned content"},[_c('div',{staticClass:"meta"},[_vm._v("Curated by")]),_vm._v(" "),_c('div',{staticClass:"header"},[_c('a',[_vm._v(_vm._s(_vm.curator))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9230c5fe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardMeta.vue
// module id = 220
// module chunks = 0